import { get, post } from './index.js'
export const fetchQRCode    = ()     => get('/auth/qrcode')
export const startSession   = ()     => post('/auth/session', {})
export const pollScanStatus = ()     => get('/auth/poll')
export const login          = ()     => post('/auth/login',   {})
export const logout         = ()     => post('/auth/logout',  {})
export const fetchMe        = ()     => get('/auth/me')
